import React from 'react';
import {IconButton} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

type CloseIconButtonProps = {
    onClick: () => void;
};

const CloseIconButton: React.FC<CloseIconButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <IconButton onClick={(e) => handleClick(e)}>
            <CloseIcon/>
        </IconButton>
    );
};
export default CloseIconButton;
